import { apiGet, apiPatch } from './client';
import type { SwapStatus, SwapStatusBatchRequest } from '../types/SwapStatus';

export function getSwapStatuses(): Promise<SwapStatus[]> {
  return apiGet<SwapStatus[]>('/api/swap-statuses');
}

export function saveBatchSwapStatuses(added: SwapStatus[], modified: SwapStatus[], deletedIds: number[]): Promise<SwapStatus[]> {
  return apiPatch<SwapStatusBatchRequest, SwapStatus[]>('/api/swap-statuses/batch', { added, modified, deleted: deletedIds });
}
